<template>
  <transition name="accueil" appear @enter="enter" @leave="leave">
    <div class="global">
      <div class="transition-block white"></div>
      <div class="transition-block black"></div>
      <main>
        <div class="home-content">
          <div class="home-content__drag-area" draggable="true">
            <div class="img-drag">
              <svg
                ref="svg"
                width="400"
                height="528"
                viewBox="0 0 400 544"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <filter id="distortionFilter">
                    <feTurbulence
                      type="fractalNoise"
                      baseFrequency="0.01 0.002"
                      numOctaves="4"
                      seed="5"
                      stitchTiles="stitch"
                      x="0%"
                      y="0%"
                      width="100%"
                      height="100%"
                      result="noise"
                    />
                    <feDisplacementMap
                      in="SourceGraphic"
                      in2="noise"
                      scale="0"
                      xChannelSelector="R"
                      yChannelSelector="B"
                      x="0%"
                      y="0%"
                      width="100%"
                      height="100%"
                      filterUnits="userSpaceOnUse"
                    />
                  </filter>
                </defs>
                <g filter="url(#distortionFilter)">
                  <image
                    @click="dragStart"
                    x="0"
                    y="10"
                    href="../../static/images/photo-davy.jpg"
                    width="400"
                    height="512"
                  />
                </g>
              </svg>
              <p ref="dragText" class="drag-text">(DRAG IT)</p>
            </div>
          </div>
          <h2 class="content__title">Davy Jacquemard</h2>

          <h3 class="decouvrir" @mouseenter="onLinkMouseEnter" @mouseleave="onLinkMouseLeave">
            <router-link to="/projets">Découvrir</router-link>
          </h3>
        </div>
      </main>
    </div>
  </transition>
</template>
<script>
import DraggableImage from "../script/draggableImage";
export default {
  name: "Accueil",
  data() {
    return {};
  },
  methods: {
    dragImage() {
      // Preload fonts
      const preloadFonts = () => {
        return new Promise((resolve, reject) => {
          WebFont.load({
            typekit: {
              id: "mto6dlj"
            },
            active: resolve
          });
        });
      };

      Promise.all([preloadFonts()]).then(() => {
        [...document.querySelectorAll(".img-drag")].forEach(
          draggableEl => new DraggableImage(draggableEl)
        );
        document.body.classList.remove("loading");
      });
    },
    dragStart() {
      var dragTest = this.$refs.dragText;
      TweenMax.to(dragTest, 1, {
        y: "-200%",
        opacity: 0,
        ease: Power4.easeOut
      });
    },
    onLinkMouseEnter() {
      if (window.innerWidth > 980) {
        var cursorCircle = document.querySelector(".cursor__inner--circle");
        cursorCircle.classList.add("cursor-animate");
        TweenMax.to(cursorCircle, 0.3, {
          width: 60 + "px",
          height: 60 + "px",
          top: -20 + "px",
          left: -20 + "px",
          ease: "back.out(1.7)"
        });
      }
    },
    onLinkMouseLeave() {
      if (window.innerWidth > 980) {
        var cursorCircle = document.querySelector(".cursor__inner--circle");
        cursorCircle.classList.remove("cursor-animate");
        TweenMax.to(cursorCircle, 0.3, {
          width: 20,
          height: 20,
          top: 0,
          left: 0,
          ease: "back.out(1.7)"
        });
      }
    },
    enter(el, done) {
      var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
      var image = el.querySelector(".home-content__drag-area");
      var name = el.querySelector(".content__title");
      var decouvrir = el.querySelector(".decouvrir");

      TweenMax.to(blockWhite, 0.8, {
        delay: 0.4,
        height: "100vh",
        ease: Power4.easeOut
      });
      TweenMax.to(blockWhite, 0.8, {
        delay: 0.8,
        y: "100vh",
        ease: Power4.easeOut
      });
      TweenMax.to(blockWhite, {
        delay: 1.6,
        height: 0,
        ease: Power4.easeOut
      });

      TweenMax.to(blockBlack, 0.8, {
        delay: 1.2,
        y: "100vh",
        ease: Power4.easeOut
      });
      TweenMax.to(blockBlack, {
        delay: 2,
        height: 0,
        ease: Power4.easeOut,
        onComplete: done
      });
      TweenMax.to([blockBlack, blockWhite], 0, {
        delay: 1.6,
        "z-index": 0,
        ease: Power4.easeOut
      });

      TweenMax.set([image, name, decouvrir], {
        opacity: 0,
      });
      TweenMax.set(image, {
        y: "100px"
      });
      TweenMax.to(image, 0.8, {
        delay: 2,
        opacity: 1,
        y: 0,
        ease: Power4.easeOut
      });
      TweenMax.to(name, 0.8, {
        delay: 1.6,
        opacity: 1,
      //  y: 0,
        ease: Power4.easeOut
      });
      TweenMax.to(decouvrir, 0.8, {
        delay: 1.8,
        opacity: 1,
     //   y: 0,
        ease: Power4.easeOut
      });

      /* TweenMax.set(main, {
        autoAlpha: 0
      });
      TweenMax.to(main, {
        delay: 0.8,
        autoAlpha: 1,
        ease: Power4.easeOut
      });*/
    },
    leave(el, done) {
      var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
      TweenMax.set([blockBlack, blockWhite], {
        height: "100vh",
        "z-index": 990
      });
      TweenMax.to(blockWhite, 0.8, {
        delay: 0.2,
        y: 0,
        ease: Power4.easeOut
      });
      TweenMax.to(blockBlack, 0.8, {
        delay: 0.6,
        y: 0,
        ease: Power4.easeOut,
        onComplete: done
      });
    }
  },
  created() {
    this.dragImage();
  },
  mounted() {
    if (window.innerWidth < 760) {
      var svg = this.$refs.svg;
      svg.setAttribute("width", "200px");
      svg.setAttribute("height", "264px");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang='scss'>
$break-medium: 768px;
$break-large: 1260px;
.global {
  margin-top: 62px;
  .transition-block {
    width: 100vw;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: #ea5242;
    &.black {
      background-color: #0e0d10;
      z-index: 99;
      height: 100%;
    }
  }
  .home-content {
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100vw;
    height: calc(100vh - 62px);
    position: relative;
    justify-content: flex-start;
    align-items: center;

    &__drag-area {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .img-wrap {
        position: relative;
        max-width: 100%;
        display: flex;
        flex-wrap: wrap;
        cursor: grab;
        margin: 3rem 15rem 3rem 3rem;
        flex: none;
      }

      .img-drag {
        position: relative;
        max-width: 100%;
        display: flex;
        flex-wrap: wrap;
        cursor: grab;
        margin: 3rem 15rem 3rem 3rem;
        //transform: translate(20vw, 10vh);
      }
      .img-drag svg {
        display: block;
        @media screen and (max-width: $break-medium) {
        }
      }
    }
    h2.content__title,
    h3 {
      font-size: 8vw;
      mix-blend-mode: exclusion;
      font-family: bely-display, sans-serif;
      font-weight: 900;
      margin: 0;
      position: relative;
      z-index: 100;
      color: #eaeaef;
      text-align: center;
      transform: translateY(30vh);
    }
    h3.decouvrir {
      font-size: 9vw;
      transform: translateY(65vh);
      z-index: 12;
      @media screen and (min-width: $break-medium) {
        font-size: 3vw;
      }
      &:after {
        content: "";
        position: absolute;
        width: 0;
        margin-top: 3.5vw;
        height: 5px;
        left: 0;
        background-color: #fff;
        // transform: translateX(100%);
        transition: width 0.5s ease;
      }
      &:hover:after {
        width: 100%;
        transition: width 0.5s ease;
      }
    }
    .drag-text {
      font-family: "Uni Sans", sans-serif;
      position: absolute;
      z-index: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 100%;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue